// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff");
}
@font-face {
  font-family: "Inter", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff");
}
@font-face {
  font-family: "Source Sans Pro", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff");
}
.accountSettings_pageWrapper__PQa-P {
  display: flex;
  justify-content: center;
  padding: 0;
  background: #ffffff;
}

/* Center container */
.accountSettings_centerBox__YYHUj {
  width: 100%;
  max-width: 1200px;
}

/* Grid: 2 columns, auto rows; responsive to 1 column on small screens */
.accountSettings_grid__mTuZ8 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

/* Card (each tile) */
.accountSettings_card__XaAUX {
  background: #F5F5F5;
  padding: 20px 20px 0 20px;
  box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, 0.75);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 160px;
  border: 1px solid #ced4da;
}
.accountSettings_card__XaAUX .accountSettings_gfs-26__Mgp2s {
  font-size: 26px;
  font-weight: 300;
  color: #666666;
  line-height: 1.3;
  padding-bottom: 10px;
}
.accountSettings_card__XaAUX .accountSettings_gfs-16__S\\+r\\+n {
  font-size: 16px;
  color: #666666;
  font-weight: 300;
}
.accountSettings_card__XaAUX .accountSettings_mb-20__rwoJz {
  margin-bottom: 20px;
}
.accountSettings_card__XaAUX .accountSettings_pl-30__wrNOp {
  padding-left: 30px;
}

/* Inner wrapper to separate header/body/footer */
.accountSettings_cardInner__Ke9i\\+ {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Header */
.accountSettings_cardHeader__17Ldt {
  margin-bottom: 20px;
}

/* placeholder to avoid linter confusion */
/* Footer (CTA) */
.accountSettings_cardFooter__BBDyx {
  margin-top: auto;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}

/* CTA button */
.accountSettings_ctaBtn__sYpft {
  background: #9e9e9e;
  color: #ffffff;
  padding: 10px 14px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  font-size: 18px;
  margin-top: 10px;
}

/* Typography utilities (use bracket notation in JS) */
.accountSettings_gfs-26__Mgp2s {
  font-size: 26px;
  font-weight: 600;
}

.accountSettings_gfs-14__vbKBq {
  font-size: 14px;
}

.accountSettings_gfw-3__3PJk1 {
  font-weight: 300;
}

.accountSettings_gfw-7__D81-o {
  font-weight: 700;
}

.accountSettings_text-green-dark__BEm0H {
  color: #4f785f !important;
}

/* Spacing utilities */
.accountSettings_mb-10__r-oU1 {
  margin-bottom: 10px;
}

.accountSettings_mb-30__-kLtK {
  margin-bottom: 30px;
}

/* Button base (kept for compatibility) */
.accountSettings_btn__8dcBs {
  display: inline-block;
  padding: 10px 16px;
  border-radius: 0px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  width: 100%;
}
.accountSettings_btn__8dcBs:hover {
  text-decoration: underline;
  background-color: #858585;
}

/* Responsive: single column on small screens */
@media (max-width: 767px) {
  .accountSettings_grid__mTuZ8 {
    grid-template-columns: 1fr;
  }
  .accountSettings_card__XaAUX {
    min-height: auto;
  }
  .accountSettings_cardFooter__BBDyx {
    justify-content: stretch;
  }
  .accountSettings_ctaBtn__sYpft {
    width: 100%;
  }
  .accountSettings_pl-30__wrNOp {
    padding-left: 0px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/base/_fonts.scss","webpack://./src/styles/myAccount/accountSettings.module.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAOA;EACE,kCAAA;EACA,oRAAA;ACHF;ADQA;EACE,gCAAA;EACA,wPAAA;ACNF;ADUA;EACE,0CAAA;EACA,wWAAA;ACRF;AAZA;EACI,aAAA;EACA,uBAAA;EACA,UAAA;EACA,mBC2CI;AD7BR;;AAVA,qBAAA;AACA;EACI,WAAA;EACA,iBAAA;AAaJ;;AAVA,wEAAA;AACA;EACI,aAAA;EACA,qCAAA;EACA,SAAA;AAaJ;;AAVA,qBAAA;AACA;EACI,mBC0EO;EDzEP,yBAAA;EACA,gDAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;EACA,yBAAA;AAaJ;AAZI;EACI,eAAA;EACA,gBCkGH;EDjGG,cC2BO;ED1BP,gBAAA;EACA,oBAAA;AAcR;AAZI;EACI,eAAA;EACA,cCqBO;EDpBP,gBC0FH;AD5EL;AAZI;EACI,mBAAA;AAcR;AAZI;EACI,kBAAA;AAcR;;AAVA,iDAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAaJ;;AAVA,WAAA;AACA;EACI,mBAAA;AAaJ;;AARA,0CAAA;AAEA,iBAAA;AACA;EACI,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,SAAA;AAUJ;;AAPA,eAAA;AACA;EACI,mBCZK;EDaL,cC/BI;EDgCJ,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBCqDC;EDpDD,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAUJ;;AAPA,sDAAA;AACA;EACI,eAAA;EACA,gBCuCC;AD7BL;;AARA;EACI,eAAA;AAWJ;;AATA;EACI,gBC8BC;ADlBL;;AAVA;EACI,gBC+BC;ADlBL;;AAXA;EACI,yBAAA;AAcJ;;AAZA,sBAAA;AACA;EACI,mBAAA;AAeJ;;AAZA;EACI,mBAAA;AAeJ;;AAZA,yCAAA;AACA;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;AAeJ;AAdI;EACI,0BAAA;EACA,yBC/DC;AD+ET;;AAXA,+CAAA;AACA;EACI;IACI,0BAAA;EAcN;EAZE;IACI,gBAAA;EAcN;EAZE;IACI,wBAAA;EAcN;EAZE;IACI,WAAA;EAcN;EAZE;IACI,4BAAA;EAcN;AACF","sourcesContent":["// -----------------------------------------------------------------------------\n// This file contains all @font-face declarations, if any.\n// -----------------------------------------------------------------------------\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap');\n\n@font-face {\n  font-family: \"DM Sans\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff2'),\n  url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff');\n  \n}\n\n@font-face {\n  font-family: \"Inter\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff');\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff');\n}","@use '../abstracts/variables' as *;\n\n.pageWrapper {\n    display: flex;\n    justify-content: center;\n    padding: 0;\n    background: $white;\n\n}\n\n/* Center container */\n.centerBox {\n    width: 100%;\n    max-width: 1200px;\n}\n\n/* Grid: 2 columns, auto rows; responsive to 1 column on small screens */\n.grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 30px;\n}\n\n/* Card (each tile) */\n.card {\n    background: $bg-white1;\n    padding: 20px 20px 0 20px;\n    box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, .75);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    min-height: 160px;\n    border: 1px solid $border-grey;\n    .gfs-26 {\n        font-size: 26px;\n        font-weight: $fw3;\n        color: $light-gray2;\n        line-height:1.3;\n        padding-bottom:10px;\n    }\n    .gfs-16 {\n        font-size: 16px;\n        color: $light-gray2;\n        font-weight: $fw3;\n    }\n    .mb-20{\n        margin-bottom: 20px;\n    }\n    .pl-30{\n        padding-left: 30px;\n    }\n}\n\n/* Inner wrapper to separate header/body/footer */\n.cardInner {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n/* Header */\n.cardHeader {\n    margin-bottom: 20px;\n}\n\n\n\n/* placeholder to avoid linter confusion */\n\n/* Footer (CTA) */\n.cardFooter {\n    margin-top: auto;\n    display: flex;\n    justify-content: flex-start;\n    gap: 10px;\n}\n\n/* CTA button */\n.ctaBtn {\n    background: $grey5;\n    color: $white;\n    padding: 10px 14px;\n    border-radius: 6px;\n    text-decoration: none;\n    font-weight: $fw7;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    cursor: pointer;\n    font-size:18px;\n    margin-top: 10px;\n}\n\n/* Typography utilities (use bracket notation in JS) */\n.gfs-26 {\n    font-size: 26px;\n    font-weight: $fw6;\n}\n.gfs-14 {\n    font-size: 14px;\n}\n.gfw-3 {\n    font-weight: $fw3;\n}\n.gfw-7 {\n    font-weight: $fw7;\n}\n.text-green-dark{\n    color: #4f785f !important;\n}\n/* Spacing utilities */\n.mb-10 {\n    margin-bottom: 10px;\n}\n\n.mb-30 {\n    margin-bottom: 30px;\n}\n\n/* Button base (kept for compatibility) */\n.btn {\n    display: inline-block;\n    padding: 10px 16px;\n    border-radius: 0px;\n    text-align: center;\n    cursor: pointer;\n    text-decoration: none;\n    width:100%;\n    &:hover{\n        text-decoration:underline;\n        background-color:$grey6;\n    }\n}\n\n\n/* Responsive: single column on small screens */\n@media (max-width: 767px) {\n    .grid {\n        grid-template-columns: 1fr;\n    }\n    .card {\n        min-height: auto;\n    }\n    .cardFooter {\n        justify-content: stretch;\n    }\n    .ctaBtn {\n        width: 100%;\n    }\n    .pl-30{\n        padding-left: 0px !important;\n    }\n}","// -----------------------------------------------------------------------------\n// This file contains all application-wide Sass variables.\n// -----------------------------------------------------------------------------\n\n\n//Fonts \n\n\n@import \"../base/fonts\";\n\n\n$roboto-regular : 'Roboto-regular';\n$roboto-bold: 'Roboto-bold';\n$roboto-medium: 'Roboto-medium';\n$roboto-light-italic: 'Roboto-light-italic';\n\n/// Regular font family\n/// @type List\n//$text-font-stack: 'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default;\n\n/// Code (monospace) font family\n/// @type List\n//$code-font-stack: 'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default;\n\n\n\n\n\n/// Copy text color\n/// @type Color\n$text-color: rgb(34, 34, 34) !default;\n\n/// Main brand color\n/// @type Color\n$brand-color: rgb(229, 0, 80) !default;\n\n/// Light grey\n/// @type Color\n$light-grey: rgb(237, 237, 237) !default;\n\n/// Medium grey\n/// @type Color\n$mid-grey: rgb(153, 153, 153) !default;\n\n/// Dark grey\n/// @type Color\n$dark-grey: rgb(68, 68, 68) !default;\n\n$black: #000000;\n$white: #ffffff;\n$gray: #222222;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n\n$hover-grey: #b8babf;\n$gray7:#333333;\n$gray8:#CCCCCC;\n$gray9:#dddddd;\n$gray10:#57606a;\n$gray11:#999999;\n$light-gray : #414141;\n$light-gray2 : #666666;\n$gray2 : #4F4F4F;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n$grey7 : #d9d9d9;\n$grey8 : #e6e9ee;\n$grey9 : #e6e6e9;\n$hover-grey: #b8babf;\n$stone : #CACACA;\n$gray-bg :#EBF9F0;\n$green:#046A38;\n$green2:#1EE576;\n$green3:#19C063;\n$green5:#2a8056;\n$green4:#73c573;\n$green7:#70c66f;\n$dark-green:#00873C;\n$light-green:#00B140;\n$light-green1 : #4f785f;\n$red : #FF0000;\n$light-red:#ff3c3c;\n$yellow:#FFB034;\n$dark-yellow:#e2a014;\n$yellow-hover:#cd7d00;\n$blue :#0A1AB4;\n$orange:#EA6B1F;\n$purple:#6A1B85;\n$offwhite:#F5F7F5;\n$offwhite1:#E0E0E0;\n$bg-grey-login:#f2f3f6;\n$border-grey: #ced4da;\n$bl-grey: #6c757d;\n$bl-green:#00703c;\n$bl-darkgrey: #b0b0b0;\n$bg-white1:#F5F5F5;\n$bg-white2:#FAFAFA;\n$red1: #d1002f;\n\n$yellow-hover:#cd7d00;\n\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$margin0:0px;\n$margin10:10px;\n$margin15:15px; \n$margin20:20px;\n$margin30:30px; \n$margin40:40px;\n$margin50:50px;\n$margin60:60px;\n\n$padding0:0px;\n$padding10:10px;\n$padding15:15px;    \n$padding16:16px;    \n$padding20:20px;\n$padding30:30px;  \n$padding40:40px;\n$padding50:50px;\n\n$br-0:0px;\n\n$br-0:0px;\n$fw1:100;\n$fw2:200;\n$fw3:300;\n$fw4:400;\n$fw5:500;\n$fw6:600;\n$fw7:700;\n$fw8:800;\n$fw9:900;\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$source-sans-pro:   \"Source Sans Pro\" , sans-serif ;\n\n/// Container's maximum width\n/// @type Length\n$max-width: 1180px !default;\n\n\n\n\n\n/// Breakpoints map\n/// @prop {String} keys - Keys are identifiers mapped to a given length\n/// @prop {Map} values - Values are actual breakpoints expressed in pixels\n$breakpoints: (\n  'small': 320px,\n  'medium': 768px,\n  'large': 1024px,\n) !default;\n\n\n\n\n\n\n/// Relative or absolute URL where all assets are served from\n/// @type String\n/// @example scss - When using a CDN\n///   $base-url: 'https://cdn.example.com/assets/';\n$base-url: '/assets/' !default;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrapper": `accountSettings_pageWrapper__PQa-P`,
	"centerBox": `accountSettings_centerBox__YYHUj`,
	"grid": `accountSettings_grid__mTuZ8`,
	"card": `accountSettings_card__XaAUX`,
	"gfs-26": `accountSettings_gfs-26__Mgp2s`,
	"gfs-16": `accountSettings_gfs-16__S+r+n`,
	"mb-20": `accountSettings_mb-20__rwoJz`,
	"pl-30": `accountSettings_pl-30__wrNOp`,
	"cardInner": `accountSettings_cardInner__Ke9i+`,
	"cardHeader": `accountSettings_cardHeader__17Ldt`,
	"cardFooter": `accountSettings_cardFooter__BBDyx`,
	"ctaBtn": `accountSettings_ctaBtn__sYpft`,
	"gfs-14": `accountSettings_gfs-14__vbKBq`,
	"gfw-3": `accountSettings_gfw-3__3PJk1`,
	"gfw-7": `accountSettings_gfw-7__D81-o`,
	"text-green-dark": `accountSettings_text-green-dark__BEm0H`,
	"mb-10": `accountSettings_mb-10__r-oU1`,
	"mb-30": `accountSettings_mb-30__-kLtK`,
	"btn": `accountSettings_btn__8dcBs`
};
export default ___CSS_LOADER_EXPORT___;
